import { envConfig } from '@globals/env'
import { loadGainsightPx } from '@globals/gainsightPx'
import { loadLogRocket } from '@globals/logRocket'
import { initAPI } from '@kudos/http-client'
// eslint-disable-next-line local/require-direct-mui-imports
import { LicenseInfo } from '@mui/x-license'
import { StrictMode } from 'react'
import * as ReactDOM from 'react-dom/client'
import { App } from './App'

// Initialize the API with base URL and default locale for this environment
initAPI({ apiUrl: envConfig.API_URL, apiLocale: 'en' })

// Set the license key for the MUI X pro components
LicenseInfo.setLicenseKey(envConfig.MUI_PRO_KEY)

// Install the Gainsight PX tag (no-op outside the production deploy).
loadGainsightPx()

// SYN-7849 spike: inject the LogRocket session-replay + debugging POC loader.
// No-op (nothing injected or fetched) unless a LOGROCKET_APP_ID is configured
loadLogRocket()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
)
